// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4c4a4125","455":"ba192114"}[chunkId] + ".chunk.js";
};